// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skills-container {
  padding: 5% 10%;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.skills-container svg {
  color: white;
}

.skills-container .skills-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 50px;
}

.skills-container .skills-grid .skill {
  align-items: center;
  text-align: left;
}

.chip {
  color: rgb(39, 40, 34) !important;
  background-color: white !important;
  font-size: 0.8rem !important;
  height: 25px !important;
}
.chip span {
  font-family: "Courier Prime", monospace;
  color: rgb(39, 40, 34);
}
.chip svg {
  height: 15px !important;
}

.flex-chips {
  line-height: 2;
  margin: 0.5;
}
.flex-chips .chip-title {
  color: white;
  padding-right: 10px;
}

.flex-chips .MuiChip-root {
  margin-right: 0.5em;
}

.flex-chips .MuiChip-outlined {
  background-color: #e0e0e0;
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.flex-chips .MuiChip-outlined span {
  color: rgb(39, 40, 34);
}

@media screen and (max-width: 768px) {
  .skills-container {
    display: block;
    padding-left: 5%;
    padding-right: 5%;
  }
  .skills-container .skills-grid {
    display: initial;
  }
  .skills-container .skills-grid .skill {
    padding-bottom: 5%;
  }
}
@media screen and (max-width: 567px) {
  .skills {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Expertise.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AACI;EACI,YAAA;AACR;;AAGA;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iCAAA;EACA,kCAAA;EACA,4BAAA;EACA,uBAAA;AAAJ;AAEI;EACI,uCAAA;EACA,sBAAA;AAAR;AAGI;EACI,uBAAA;AADR;;AAKA;EACI,cAAA;EACA,WAAA;AAFJ;AAII;EACI,YAAA;EACA,mBAAA;AAFR;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,+EAAA;AAHJ;;AAOA;EACI,sBAAA;AAJJ;;AAQI;EACI;IACI,cAAA;IACA,gBAAA;IACA,iBAAA;EALV;EAQM;IACI,gBAAA;EANV;EASM;IACI,kBAAA;EAPV;AACF;AAUI;EACI;IACI,eAAA;EARV;AACF","sourcesContent":[".skills-container {\n    padding: 5% 10%;\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n\n    svg {\n        color: white;\n    }\n}\n  \n.skills-container .skills-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 50px;\n}\n  \n.skills-container .skills-grid .skill {\n    align-items: center;\n    text-align: left;\n}\n  \n.chip {\n    color: rgb(39, 40, 34) !important;\n    background-color: white !important;\n    font-size: 0.8rem !important;\n    height: 25px !important;\n  \n    span {\n        font-family: 'Courier Prime', monospace;\n        color: rgb(39, 40, 34);\n    }\n  \n    svg {\n        height: 15px !important;\n    }\n}\n\n.flex-chips {\n    line-height: 2;\n    margin: 0.5;\n\n    .chip-title {\n        color: white;\n        padding-right: 10px;\n    }\n}\n\n.flex-chips .MuiChip-root {\n    margin-right: 0.5em;\n}\n\n.flex-chips .MuiChip-outlined {\n    background-color: #e0e0e0;\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n        monospace;\n}\n\n.flex-chips .MuiChip-outlined span {\n    color: rgb(39, 40, 34);\n}\n\n@media screen {\n    @media (max-width: 768px) {\n        .skills-container {\n            display: block;\n            padding-left: 5%;\n            padding-right: 5%;\n        }\n    \n        .skills-container .skills-grid {\n            display: initial;\n        }\n        \n        .skills-container .skills-grid .skill {\n            padding-bottom: 5%;\n        }\n    }\n\n    @media (max-width: 567px) {\n        .skills {\n            font-size: 12px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
